import * as Sentry from '@sentry/react';
import {config} from '../constants';
import {User} from '../types';

let isInitialized = false;

export function initSentry(): void {
  if (!config.sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: config.sentryDsn,
    enabled: process.env.NODE_ENV === 'production',
  });

  isInitialized = true;
}

export function captureException(
  error: Error,
  context?: {endpoint?: string; status?: number},
): void {
  if (!isInitialized) return;

  Sentry.captureException(error, {
    contexts: context
      ? {api: {endpoint: context.endpoint, status: context.status}}
      : undefined,
  });
}

export function setUser(user: User | null): void {
  if (!isInitialized) return;

  if (user) {
    Sentry.setUser({
      id: user.id,
      email: user.email ?? undefined,
      username: user.displayName,
    });
  } else {
    Sentry.setUser(null);
  }
}
